// Stripe Configuration
export const stripeConfig = {
  publishableKey:
    "pk_test_51T1ZgKAsZ0kVkojVJO9PwPtrrDeec4uV77s5y7PJWI2rrdK3xbrgxCO02sW9gTuxyEdj5lJcrihdehp7WtelLisk00HQgxTLio",

  // EASIEST METHOD: Payment Links
  // Create these at: https://dashboard.stripe.com/test/payment-links
  paymentLinks: {
    monthly: "https://buy.stripe.com/test_bJecN41B0f5ObbZgeT2kw00",
    annual: "https://buy.stripe.com/test_3cI9AS4Nc8Hq6VJgeT2kw01",
  },
};
